export const fetchAllPartners = [
   {
      name: "British Council",
      email: "obiianayo@gmail.com",
      phoneNumber: "08175904236",
      location: "Germany",
      status: "Active",
   },
   {
      name: "British Council",
      email: "obiianayo@gmail.com",
      phoneNumber: "08175904236",
      location: "Germany",
      status: "Inactive",
   },
   {
      name: "British Council",
      email: "obiianayo@gmail.com",
      phoneNumber: "08175904236",
      location: "Germany",
      status: "Active",
   },
   {
      name: "British Council",
      email: "obiianayo@gmail.com",
      phoneNumber: "08175904236",
      location: "Germany",
      status: "Inactive",
   },
   {
      name: "British Council",
      email: "obiianayo@gmail.com",
      phoneNumber: "08175904236",
      location: "Germany",
      status: "Active",
   },
   {
      name: "British Council",
      email: "obiianayo@gmail.com",
      phoneNumber: "08175904236",
      location: "Germany",
      status: "Active",
   },
];

export const countries = [
   {
      label: "Honduras",
      value: "honduras",
      title: "Honduras",
   },
   {
      label: "United Arab Emirates",
      value: "united arab emirates",
      title: "United Arab Emirates",
   },
   {
      label: "Djibouti",
      value: "djibouti",
      title: "Djibouti",
   },
   {
      label: "Seychelles",
      value: "seychelles",
      title: "Djibouti",
   },
   {
      label: "Antigua and Barbuda",
      value: "antigua and barbudai",
      title: "antigua and barbudai",
   },
   {
      label: "Vietnam",
      value: "vietnam",
      title: "Vietnam",
   },
   {
      label: "Hungary",
      value: "hungary",
      title: "Hungary",
   },
   {
      label: "Tajikistan",
      value: "tajikistan",
      title: "Tajikistan",
   },
   {
      label: "Belarus",
      value: "belarus",
      title: "Belarus",
   },
   {
      label: "Austria",
      value: "austria",
      title: "Austria",
   },
   {
      label: "Fiji",
      value: "fiji",
      title: "Fiji",
   },
   {
      label: "DR Congo",
      value: "DR Congo",
      title: "DR Congo",
   },
   {
      label: "Papua New Guinea",
      value: "papua new guinea",
      title: "Papua New Guinea",
   },
   {
      label: "Serbia",
      value: "serbia",
      title: "Serbia",
   },
   {
      label: "Comoros",
      value: "comoros",
      title: "Comoros",
   },
   {
      label: "Israel",
      value: "israel",
      title: "Israel",
   },
   {
      label: "Switzerland",
      value: "switzerland",
      title: "Switzerland",
   },
   {
      label: "Turkey",
      value: "turkey",
      title: "Turkey",
   },
   {
      label: "Iran",
      value: "iran",
      title: "Iran",
   },
   {
      label: "Germany",
      value: "germany",
      title: "Germany",
   },
   {
      label: "Togo",
      value: "togo",
      title: "Togo",
   },
   {
      label: "Sierra Leone",
      value: "sierra leone",
      title: "Sierra Leone",
   },
   {
      label: "Guyana",
      value: "guyana",
      title: "Guyana",
   },
   {
      label: "Andorra",
      value: "andorra",
      title: "Andorra",
   },
   {
      label: "Bhutan",
      value: "bhutan",
      title: "Bhutan",
   },
   {
      label: "Laos",
      value: "laos",
      title: "Laos",
   },
   {
      label: "Dominica",
      value: "dominica",
      title: "Dominica",
   },
   {
      label: "Paraguay",
      value: "paraguay",
      title: "Paraguay",
   },
   {
      label: "Thailand",
      value: "thailand",
      title: "Thailand",
   },
   {
      label: "Bulgaria",
      value: "bulgaria",
      title: "Bulgaria",
   },
   {
      label: "Libya",
      value: "libya",
      title: "Libya",
   },
   {
      label: "Lebanon",
      value: "lebanon",
      title: "Lebanon",
   },
   {
      label: "United Kingdom",
      value: "united kingdom",
      title: "United Kingdom",
   },
   {
      label: "Nicaragua",
      value: "nicaragua",
      title: "Nicaragua",
   },
   {
      label: "France",
      value: "france",
      title: "France",
   },
   {
      label: "Kyrgyzstan",
      value: "kyrgyzstan",
      title: "Kyrgyzstan",
   },
   {
      label: "El Salvador",
      value: "el salvador",
      title: "El Salvador",
   },
   {
      label: "Montenegro",
      value: "montenegro",
      title: "Montenegro",
   },
   {
      label: "Luxembourg",
      value: "luxembourg",
      title: "Luxembourg",
   },
   {
      label: "Italy",
      value: "italy",
      title: "Italy",
   },
   {
      label: "Turkmenistan",
      value: "turkmenistan",
      title: "Turkmenistan",
   },
   {
      label: "Tanzania",
      value: "tanzania",
      title: "Tanzania",
   },
   {
      label: "South Africa",
      value: "south africa",
      title: "South Africa",
   },
   {
      label: "Marshall Islands",
      value: "marshall islands",
      title: "Marshall Islands",
   },
   {
      label: "Suriname",
      value: "suriname",
      title: "Suriname",
   },
   {
      label: "Singapore",
      value: "singapore",
      title: "Singapore",
   },
   {
      label: "Denmark",
      value: "denmark",
      title: "Denmark",
   },
   {
      label: "Cabo Verde",
      value: "cabo verde",
      title: "Cabo Verde",
   },
   {
      label: "Finland",
      value: "finland",
      title: "Finland",
   },
   {
      label: "Congo",
      value: "congo",
      title: "Congo",
   },
   {
      label: "Myanmar",
      value: "myanmar",
      title: "Myanmar",
   },
   {
      label: "Norway",
      value: "norway",
      title: "Norway",
   },
   {
      label: "Kenya",
      value: "kenya",
      title: "Kenya",
   },
   {
      label: "Saint Kitts & Nevis",
      value: "saint kitts & nevis",
      title: "Saint Kitts",
   },
   {
      label: "South Korea",
      value: "south korea",
      title: "South Korea",
   },
   {
      label: "Oman",
      value: "oman",
      title: "Oman",
   },
   {
      label: "State of Palestine",
      value: "state of palestine",
      title: "State of Palestine",
   },
   {
      label: "Costa Rica",
      value: "costa rica",
      title: "Costa Rica",
   },
   {
      label: "Colombia",
      value: "colombia",
      title: "Colombia",
   },
   {
      label: "Liberia",
      value: "liberia",
      title: "Liberia",
   },
   {
      label: "Ireland",
      value: "ireland",
      title: "Ireland",
   },
   {
      label: "Central African Republic",
      value: "central african republic",
      title: "Central African Republic",
   },
   {
      label: "New Zealand",
      value: "new zealand",
      title: "New Zealand",
   },
   {
      label: "Spain",
      value: "spain",
      title: "Spain",
   },
   {
      label: "Mauritania",
      value: "mauritania",
      title: "Mauritania",
   },
   {
      label: "Uganda",
      value: "uganda",
      title: "Uganda",
   },
   {
      label: "Argentina",
      value: "argentina",
      title: "Argentina",
   },
   {
      label: "Malta",
      value: "malta",
      title: "Malta",
   },
   {
      label: "Algeria",
      value: "algeria",
      title: "Algeria",
   },
   {
      label: "Sudan",
      value: "sudan",
      title: "Sudan",
   },
   {
      label: "Brunei",
      value: "brunei",
      title: "Brunei",
   },
   {
      label: "Ukraine",
      value: "ukraine",
      title: "Ukraine",
   },
   {
      label: "Panama",
      value: "panama",
      title: "Kuwait",
   },
   {
      label: "Kuwait",
      value: "kuwait",
      title: "Kuwait",
   },
   {
      label: "Croatia",
      value: "croatia",
      title: "Croatia",
   },
   {
      label: "Moldova",
      value: "moldova",
      title: "Moldova",
   },
   {
      label: "Iraq",
      value: "iraq",
      title: "Iraq",
   },
   {
      label: "Georgia",
      value: "georgia",
      title: "Georgia",
   },
   {
      label: "Belize",
      value: "belize",
      title: "Belize",
   },
   {
      label: "Bahamas",
      value: "bahamas",
      title: "Bahamas",
   },
   {
      label: "Monaco",
      value: "monaco",
      title: "Monaco",
   },
   {
      label: "Afghanistan",
      value: "afghanistan",
      title: "Afghanistan",
   },
   {
      label: "Liechtenstein",
      value: "liechtenstein",
      title: "Liechtenstein",
   },
   {
      label: "Poland",
      value: "poland",
      title: "Poland",
   },
   {
      label: "Canada",
      value: "canada",
      title: "Canada",
   },
   {
      label: "Morocco",
      value: "morocco",
      title: "Morocco",
   },
   {
      label: "Eritrea",
      value: "eritrea",
      title: "Eritrea",
   },
   {
      label: "Saudi Arabia",
      value: "saudi arabia",
      title: "Saudi Arabia",
   },
   {
      label: "Uruguay",
      value: "uruguay",
      title: "Uruguay",
   },
   {
      label: "Iceland",
      value: "iceland",
      title: "Iceland",
   },
   {
      label: "San Marino",
      value: "san marino",
      title: "San Marino",
   },
   {
      label: "Uzbekistan",
      value: "uzbekistan",
      title: "Uzbekistan",
   },
   {
      label: "United States",
      value: "united states",
      title: "United States",
   },
   {
      label: "Peru",
      value: "peru",
      title: "Peru",
   },
   {
      label: "Angola",
      value: "angola",
      title: "Angola",
   },
   {
      label: "Bosnia and Herzegovina",
      value: "bosnia and herzegovina",
      title: "Bosnia and Herzegovina",
   },
   {
      label: "Mongolia",
      value: "mongolia",
      title: "Mongolia",
   },
   {
      label: "Malaysia",
      value: "malaysia",
      title: "Malaysia",
   },
   {
      label: "Mozambique",
      value: "mozambique",
      title: "Mozambique",
   },
   {
      label: "Ghana",
      value: "ghana",
      title: "Ghana",
   },
   {
      label: "Vanuatu",
      value: "vanuatu",
      title: "Vanuatu",
   },
   {
      label: "Yemen",
      value: "yemen",
      title: "Yemen",
   },
   {
      label: "Armenia",
      value: "armenia",
      title: "Armenia",
   },
   {
      label: "Jamaica",
      value: "jamaica",
      title: "Jamaica",
   },
   {
      label: "Nepal",
      value: "nepal",
      title: "Nepal",
   },
   {
      label: "Qatar",
      value: "qatar",
      title: "Nepal",
   },
   {
      label: "Albania",
      value: "albania",
      title: "Albania",
   },
   {
      label: "Barbados",
      value: "barbados",
      title: "Barbados",
   },
   {
      label: "Venezuela",
      value: "venezuela",
      title: "Venezuela",
   },
   {
      label: "Madagascar",
      value: "madagascar",
      title: "Madagascar",
   },
   {
      label: "Indonesia",
      value: "indonesia",
      title: "Indonesia",
   },
   {
      label: "Lithuania",
      value: "lithuania",
      title: "Lithuania",
   },
   {
      label: "Cameroon",
      value: "cameroon",
      title: "Cameroon",
   },
   {
      label: "Côte d'Ivoire",
      value: "Côte d'Ivoire",
      title: "Côte d'Ivoire",
   },
   {
      label: "North Korea",
      value: "north korea",
      title: "North Korea",
   },
   {
      label: "Australia",
      value: "australia",
      title: "Australia",
   },
   {
      label: "Namibia",
      value: "namibia",
      title: "Namibia",
   },
   {
      label: "Niger",
      value: "niger",
      title: "Niger",
   },
   {
      label: "Gambia",
      value: "gambia",
      title: "Gambia",
   },
   {
      label: "Botswana",
      value: "botswana",
      title: "Botswana",
   },
   {
      label: "Gabon",
      value: "gabon",
      title: "Gabon",
   },
   {
      label: "Sao Tome & Principe",
      value: "Sao Tome & Principe",
      title: "Sao Tome & Principe",
   },
   {
      label: "Lesotho",
      value: "lesotho",
      title: "Lesotho",
   },
   {
      label: "Sri Lanka",
      value: "sri lanka",
      title: "Sri Lanka",
   },
   {
      label: "Brazil",
      value: "brazil",
      title: "Brazil",
   },
   {
      label: "Burkina Faso",
      value: "burkina faso",
      title: "Burkina Faso",
   },
   {
      label: "North Macedonia",
      value: "north macedonia",
      title: "North Macedonia",
   },
   {
      label: "Slovenia",
      value: "slovenia",
      title: "Slovenia",
   },
   {
      label: "Nigeria",
      value: "nigeria",
      title: "Nigeria",
   },
   {
      label: "Mali",
      value: "mali",
      title: "Mali",
   },
   {
      label: "Samoa",
      value: "samoa",
      title: "Samoa",
   },
   {
      label: "Guinea-Bissau",
      value: "guinea-bissau",
      title: "Guinea-Bissau",
   },
   {
      label: "Romania",
      value: "romania",
      title: "Romania",
   },
   {
      label: "Malawi",
      value: "malawi",
      title: "Malawi",
   },
   {
      label: "Chile",
      value: "chile",
      title: "Chile",
   },
   {
      label: "Latvia",
      value: "latvia",
      title: "Latvia",
   },
   {
      label: "Kazakhstan",
      value: "kazakhstan",
      title: "Kazakhstan",
   },
   {
      label: "Zambia",
      value: "zambia",
      title: "Zambia",
   },
   {
      label: "Saint Lucia",
      value: "saint lucia",
      title: "Saint Lucia",
   },
   {
      label: "Palau",
      value: "palau",
      title: "Palau",
   },
   {
      label: "Guatemala",
      value: "guatemala",
      title: "Guatemala",
   },
   {
      label: "Ecuador",
      value: "ecuador",
      title: "Ecuador",
   },
   {
      label: "Syria",
      value: "syria",
      title: "Syria",
   },
   {
      label: "Netherlands",
      value: "netherlands",
      title: "Netherlands",
   },
   {
      label: "Bahrain",
      value: "bahrain",
      title: "Bahrain",
   },
   {
      label: "Senegal",
      value: "senegal",
      title: "Senegal",
   },
   {
      label: "Cambodia",
      value: "cambodia",
      title: "Cambodia",
   },
   {
      label: "Bangladesh",
      value: "bangladesh",
      title: "Bangladesh",
   },
   {
      label: "Chad",
      value: "chad",
      title: "Chad",
   },
   {
      label: "Somalia",
      value: "somalia",
      title: "Somalia",
   },
   {
      label: "Zimbabwe",
      value: "zimbabwe",
      title: "Zimbabwe",
   },
   {
      label: "Russia",
      value: "russia",
      title: "Russia",
   },
   {
      label: "China",
      value: "china",
      title: "China",
   },
   {
      label: "Equatorial Guinea",
      value: "equatorial guinea",
      title: "Equatorial Guinea",
   },
   {
      label: "Trinidad and Tobago",
      value: "trinidad and tobago",
      title: "Trinidad and Tobago",
   },
   {
      label: "Estonia",
      value: "estonia",
      title: "Timor-Leste",
   },
   {
      label: "Timor-Leste",
      value: "timor-leste",
      title: "Timor-Leste",
   },
   {
      label: "Guinea",
      value: "guinea",
      title: "Guinea",
   },
   {
      label: "Rwanda",
      value: "rwanda",
      title: "Rwanda",
   },
   {
      label: "Mexico",
      value: "mexico",
      title: "Mexico",
   },
   {
      label: "Mauritius",
      value: "mauritius",
      title: "Mauritius",
   },
   {
      label: "Japan",
      value: "japan",
      title: "Japan",
   },
   {
      label: "Benin",
      value: "benin",
      title: "Benin",
   },
   {
      label: "Cyprus",
      value: "cyprus",
      title: "Cyprus",
   },
   {
      label: "Kiribati",
      value: "kiribati",
      title: "Kiribati",
   },
   {
      label: "Burundi",
      value: "burundi",
      title: "Burundi",
   },
   {
      label: "Tunisia",
      value: "tunisia",
      title: "Tunisia",
   },
   {
      label: "Tuvalu",
      value: "tuvalu",
      title: "Tuvalu",
   },
   {
      label: "Bolivia",
      value: "bolivia",
      title: "Bolivia",
   },
   {
      label: "Eswatini",
      value: "eswatini",
      title: "Eswatini",
   },
   {
      label: "Belgium",
      value: "belgium",
      title: "Belgium",
   },
   {
      label: "Ethiopia",
      value: "ethiopia",
      title: "Ethiopia",
   },
   {
      label: "Haiti",
      value: "haiti",
      title: "Haiti",
   },
   {
      label: "Cuba",
      value: "cuba",
      title: "Cuba",
   },
   {
      label: "Grenada",
      value: "grenada",
      title: "Grenada",
   },
   {
      label: "South Sudan",
      value: "south sudan",
      title: "South Sudan",
   },
   {
      label: "St. Vincent & Grenadines",
      value: "St. Vincent & Grenadines",
      title: "St. Vincent & Grenadines",
   },
   {
      label: "Philippines",
      value: "philippines",
      title: "Philippines",
   },
   {
      label: "Dominican Republic",
      value: "dominican republic",
      title: "Dominican Republic",
   },
   {
      label: "Nauru",
      value: "nauru",
      title: "Nauru",
   },
   {
      label: "Czech Republic (Czechia)",
      value: "Czech Republic (Czechia)",
      title: "Czech Republic (Czechia)",
   },
   {
      label: "Tonga",
      value: "tonga",
      title: "Tonga",
   },
   {
      label: "Greece",
      value: "greece",
      title: "Greece",
   },
   {
      label: "Egypt",
      value: "egypt",
      title: "Egypt",
   },
   {
      label: "Jordan",
      value: "jordan",
      title: "Jordan",
   },
   {
      label: "Portugal",
      value: "portugal",
      title: "Portugal",
   },
   {
      label: "Azerbaijan",
      value: "azerbaijan",
      title: "Azerbaijan",
   },
   {
      label: "Sweden",
      value: "sweden",
      title: "Sweden",
   },
   {
      label: "India",
      value: "india",
      title: "India",
   },
];

export const schoolCategory = [
   {
      label: "Elementary School",
      value: "elementary school",
      title: "Elementary School",
   },
   {
      label: "High School",
      value: "high school",
      title: "High School",
   },
   {
      label: "Undergraduate",
      value: "undergraduate",
      title: "Undergraduate",
   },
   {
      label: "Diploma",
      value: "diploma",
      title: "Diploma",
   },
   {
      label: "Pre-Masters",
      value: "pre-masters",
      title: "Pre-Masters",
   },
   {
      label: "Masters degree",
      value: "masters degree",
      title: "Masters degree",
   },
   {
      label: "Doctorate",
      value: "doctorate",
      title: "Doctorate",
   },
   {
      label: "University Preparation",
      value: "university preparation",
      title: "University Preparation",
   },
   {
      label: "Vocational",
      value: "vocational",
      title: "Vocational",
   },
   {
      label: "College",
      value: "college",
      title: "College",
   },
];

export const sortedCountries = countries?.sort(function (a, b) {
   if (a.label < b.label) {
      return -1;
   }
   if (a.label > b.label) {
      return 1;
   }
   return 0;
});

export const filters = [
   {
      title: "Categories",
      submenu: schoolCategory,
   },
];

export const filterCountry = [
   {
      title: "Country",
      submenu: countries,
   },
];
export const fetchAllCourses = [
   {
      course: "Business Admin",
      partner: "British Council",
      level: "Undergraduate",
      duration: "5years",
      status: "Active",
      id: 1,
   },
   {
      course: "Business Admin",
      partner: "British Council",
      level: "Masters",
      duration: "4years",
      status: "Inactive",
      id: 2,
   },
   {
      course: "Business Admin",
      partner: "British Council",
      level: "Undergraduate",
      duration: "6years",
      status: "Active",
      id: 3,
   },
   {
      course: "Business Admin",
      partner: "British Council",
      level: "PhD",
      duration: "4years",
      status: "Inactive",
      id: 4,
   },
   {
      course: "Business Admin",
      partner: "British Council",
      level: "Masters",
      duration: "2years",
      status: "Active",
      id: 5,
   },
];

export const fetchSingleCourse = [
   {
      course: "Business Admin",
      partner: "British Council",
      level: "Undergraduate",
      duration: "5years",
      status: "Active",
      id: 1,
   },
   {
      course: "Business Admin",
      partner: "British Council",
      level: "Masters",
      duration: "4years",
      status: "Inactive",
      id: 2,
   },
   {
      course: "Business Admin",
      partner: "British Council",
      level: "Undergraduate",
      duration: "6years",
      status: "Active",
      id: 3,
   },
   {
      course: "Business Admin",
      partner: "British Council",
      level: "PhD",
      duration: "4years",
      status: "Inactive",
      id: 4,
   },
   {
      course: "Business Admin",
      partner: "British Council",
      level: "Masters",
      duration: "2years",
      status: "Active",
      id: 5,
   },
];

export const fetchAllScholarships = [
   {
      name: "Government of Turkey Scholarship..",
      deadline: "August 15, 2020",
      category: "Msc",
      status: "Published",
   },
   {
      name: "Government of Turkey Scholarship..",
      deadline: "August 15, 2020",
      category: "Msc",
      status: "Drafts",
   },
   {
      name: "Government of Turkey Scholarship..",
      deadline: "August 15, 2020",
      category: "PhD",
      status: "Successful",
   },
   {
      name: "Government of Turkey Scholarship..",
      deadline: "August 15, 2020",
      category: "Undergraduate",
      status: "Drafts",
   },
];

export const fetchAllApplications = [
   {
      name: "Mr Shola",
      email: "shola123@example.com",
      course: "Business Admin",
      phoneNumber: "08175904236",
      partner: "British Council",
      status: "Viewed",
      id: 1,
   },
   {
      name: "Mr Anayo",
      email: "obiianayo@gmail.com",
      course: "Business Admin",
      phoneNumber: "08175904236",
      partner: "British Council",
      status: "Successful",
      id: 2,
   },
   {
      name: "Mr Shola",
      email: "shola123@example.com",
      course: "Business Admin",
      phoneNumber: "08175904236",
      partner: "British Council",
      status: "Successful",
      id: 3,
   },
   {
      name: "Mr Anayo",
      email: "obiianayo@gmail.com",
      course: "Business Admin",
      phoneNumber: "08175904236",
      partner: "British Council",
      status: "Unsuccessful",
      id: 4,
   },
];

export const partnerFilter = [
   {
      title: "Status",
      submenu: [
         {
            title: "Active",
         },
         {
            title: "InActive",
         },
      ],
   },
];

export const currencies = [
   {
      label: "NGN",
      value: "NGN",
   },
   {
      label: "USD",
      value: "USD",
   },
];
